<template>
  <b-modal size="lg" id="add-estimate-item-modal" ref="addEstimateItemModal" :hide-header="true" :hide-footer="true" :no-close-on-backdrop="true">
    <b-overlay :show="overlayShow" rounded="sm">
      <!-- モーダル閉じるxボタン -->
      <b-button @click="hideModal()" aria-label="Close" class="close"><b-icon-x font-scale="2"></b-icon-x></b-button>

      <div id="est-item-search-conditions" class="p-3 mt-2 border border-dark d-inline-block rounded">
        <div id="est-project-types">
          <div class="row mb-2 ml-0 px-0 col-12">
            <h5 class="col-sm-9 pt-2 d-inline text-primary px-0">大区分</h5>
          </div>
          <div class="form-check form-check-inline px-0 mr-0 col-4" v-for="(typeName, index) in projectTypes" :key="'projectType' + index">
            <input class="form-check-input" type="radio" :id="'estProjectType' + index" name="estProjectType" data-param-name="projectType" :value="typeName" @change="changeProjectType" v-model="projectType">
            <label class="mb-0" :for="'estProjectType' + index">{{typeName}}</label>
          </div>
        </div>

        <div class="mt-5" id="est-section-s">
          <h5 class="text-primary">小区分</h5>
          <div class="d-inline" v-for="(value, index) in conditions['sectionS']" :key="'section' + index">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" :id="'estSection' + index" name="estSectionS" data-param-name="sectionS" :value="value" @change="changeSectionS" v-model="sectionS">
              <label class="mb-0" :for="'estSection' + index">{{value}}</label>
            </div>
          </div>
        </div>

        <div id="est-search-conditions" v-if="searchTypes.length">
          <h5 class="mt-5 text-primary">検索条件</h5>

          <div v-for="(type, index) in searchTypes" :key="'search' + index">

            <div v-if="type === 'season'">
              <div class="mt-3">
                <label class="mb-1">季節</label>
              </div>
              <div class="d-inline" v-for="(value, index) in conditions['seasons']" :key="'season' + index">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" :id="'estSeasonCheck' + index" name="estSeason" data-param-name="season" :value="value" v-model="season">
                  <label class="mb-0" :for="'estSeasonCheck' + index">{{value}}</label>
                </div>
              </div>
            </div>

            <div v-if="type === 'color'">
              <div class="mt-3">
                <label class="mb-1">色</label>
              </div>
              <div class="d-inline" v-for="(value, index) in conditions['colors']" :key="'color' + index">
                <div class="form-check form-check-inline mr-0 px-0 col-3">
                  <input class="form-check-input" type="checkbox" :id="'estColorCheck' + index" name="estColor" data-param-name="color" :value="value" v-model="color">
                  <label class="mb-0" :for="'estColorCheck' + index">{{value}}</label>
                </div>
              </div>
            </div>

            <div v-if="type === 'shape'">
              <div class="mt-3">
                <label class="mb-1">形</label>
              </div>
              <div class="d-inline" v-for="(value, index) in conditions['shapes']" :key="'shape' + index">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" :id="'estShapeCheck' + index" name="estShape" data-param-name="shape" :value="value" v-model="shape">
                  <label class="mb-0" :for="'estShapeCheck' + index">{{value}}</label>
                </div>
              </div>
            </div>

            <div v-if="type === 'figure'">
              <div class="mt-3">
                <label class="mb-1">形態</label>
              </div>
              <div class="d-inline" v-for="(value, index) in conditions['figures']" :key="'figure' + index">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" :id="'estFigureCheck' + index" name="estFigure" data-param-name="figure" :value="value" v-model="figure">
                  <label class="mb-0" :for="'estFigureCheck' + index">{{value}}</label>
                </div>
              </div>
            </div>

            <div v-if="type === 'price'">
              <div class="mt-3">
                <label class="mb-1">価格帯</label>
              </div>
              <div class="row">
                <div class="col-5">
                  <input type="number" name="estPriceFrom" data-param-name="priceFrom" class="form-control" v-model="priceFrom">
                </div>
                <span class="col-1 p-0 pt-2 text-center">〜</span>
                <div class="col-5">
                  <input type="number" name="estPriceTo" data-param-name="priceTo" class="form-control" v-model="priceTo">
                </div>
              </div>
            </div>

            <div v-if="type === 'maker'">
              <div class="mt-3">
                <label class="mb-1">メーカー</label>
              </div>
              <input type="text" name="estMaker" data-param-name="maker" class="form-control" v-model="maker">
            </div>

            <div v-if="type === 'flowerMaterial'">
              <div class="mt-3">
                <label class="mb-1">花材</label>
              </div>
              <input type="text" name="estFlowerMaterial" data-param-name="flowerMaterial" class="form-control" v-model="flowerMaterial">
            </div>

        <!--    <div v-if="type === 'flowerMaterialArticle'">-->
        <!--      <div class="mt-3">-->
        <!--        <label class="mb-1">花材(品目)</label>-->
        <!--      </div>-->
        <!--      <input type="text" name="estFlowerMaterialArticle" data-param-name="flowerMaterialArticle" class="form-control" v-model="flowerMaterialArticle">-->
        <!--    </div>-->

        <!--    <div v-if="type === 'flowerMaterialVariety'">-->
        <!--      <div class="mt-3">-->
        <!--        <label class="mb-1">花材(品種)</label>-->
        <!--      </div>-->
        <!--      <input type="text" name="estFlowerMaterialVariety" data-param-name="flowerMaterialVariety" class="form-control" v-model="flowerMaterialVariety">-->
        <!--    </div>-->
        <!--  </div>-->

        <!--  <div v-if="isShowItemCode">-->
        <!--    <div class="mt-3">-->
        <!--      <label class="mb-1">品番</label>-->
        <!--    </div>-->
        <!--    <input type="text" name="estItemCode" data-param-name="itemCode" class="form-control" v-model="itemCode">-->
        <!--  </div>-->
          </div>
        </div>
      </div>
      <div class="mt-3 mb-5 text-center">
        <b-button variant="btn-outline-primary" class="sub-button-color mr-3" @click="search()">検索</b-button>
      </div>

      <div id="search-result-table" v-if="searchItems.length !== 0">
        <table class="table table-bordered text-center mt-3">
          <thead class="thead-light">
            <tr>
              <th class="" style="width: 10%"></th>
              <th class="" style="width: 60%">商品名</th>
              <th class="" style="width: 30%">商品単価(税抜)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in searchItems" :key="index" >
              <td>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" name="addEstItemCode" type="checkbox" :value="item['itemCode']">
                </div>
              </td>
              <td>{{item['itemName']}}</td>
              <td>{{item['itemPrice']}}</td>
            </tr>
          </tbody>
        </table>
        <div class="my-3 text-center">
          <b-button class="estimate-menu-button" @click="addEstimateItem()">商品を追加</b-button>
        </div>
      </div>

    </b-overlay>
    <CommonModal ref="commonModal" />
  </b-modal>
</template>
<script>
import CommonModal from '@/components/CommonModal'
import SearchConditionsModel from '@/models/SearchConditionsModel'
import EstimateRegistModel from '@/models/EstimateRegistModel'
import SearchModel from '@/models/SearchModel'

export default {
  name: 'AddEstimateItemModal',
  components: { CommonModal },
  data () {
    return {
      overlayShow: false,
      isShowItemCode: false,
      projectTypes: [],
      searchTypes: [],
      conditions: {'sectionS': {}, 'seasons': {}, 'colors': {}, 'shapes': {}, 'figures': {}},
      projectType: '',
      sectionS: '',
      season: [],
      color: [],
      shape: '',
      figure: '',
      priceFrom: '',
      priceTo: '',
      maker: '',
      flowerMaterial: '',
      searchItems: []
    }
  },
  methods: {
    showModal: async function () {
      await this.$refs.addEstimateItemModal.show()

      if (localStorage.getItem('searchData') !== null) {
        this.restoreSearchConditions()
      } else {
        this.reloadProjectTypes()
      }
    },
    hideModal () {
      this.$refs.addEstimateItemModal.hide()
    },
    restoreSearchConditions: async function () {
      const searchData = JSON.parse(localStorage.getItem('searchData'))
      this.projectType = searchData.projectType[0]
      await this.reloadProjectTypes()

      for (const [key, value] of Object.entries(searchData)) {
        this[key] = Array.isArray(this[key]) ? value : value[0]
      }
    },
    changeProjectType (e) {
      this.isShowItemCode = false
      this.projectType = e.target.value
      this.setSearchTypes(e.target.value)
      // 検索条件をリセット
      this.sectionS = ''
      this.season = []
      this.color = []
      this.shape = []
      this.figure = []
      this.priceFrom = ''
      this.priceTo = ''
      this.maker = ''
      this.flowerMaterial = ''
    },
    reloadProjectTypes: async function () {
      this.overlayShow = true
      const params = {'conditionType': 'addItem'}
      const resData = await SearchConditionsModel.apiSetStore(this.$bvModal, params, () => {
        this.overlayShow = false
      })
      const sectionL = Object.values(resData.sectionL)
      if (!this.projectType.length) {
        this.projectType = sectionL[0]
      }
      this.projectTypes = sectionL
      this.setSearchTypes(this.projectType)
    },
    setSearchTypes (projectType) {
      const store = SearchConditionsModel.getStore()
      if (!store) {
        return false
      }
      const searchTypes = ['seasons', 'colors', 'shapes', 'figures']
      for (let i = 0; i < searchTypes.length; i++) {
        this.$set(this.conditions, searchTypes[i], store[searchTypes[i]])
      }
      this.$set(this.conditions, 'sectionS', store['sectionS'][projectType])

      switch (projectType) {
        case 'メインテーブル':
        case 'ゲストテーブル':
          this.searchTypes = []
          break
        case 'コーディネート':
          this.searchTypes = ['color', 'maker']
          break
        case '演出':
          this.searchTypes = ['color', 'price', 'maker']
          break
        case 'その他装飾':
          this.searchTypes = ['price']
          break
        case '贈呈':
          this.searchTypes = ['color', 'shape', 'price']
          break
        case '挙式関係':
          this.searchTypes = []
          break
        case 'ブーケ':
          this.searchTypes = ['season', 'color', 'price', 'flowerMaterial']
          break
        case 'アフターブーケ':
          this.searchTypes = ['figure', 'maker']
          break
      }
    },
    changeSectionS (section) {
      this.isShowItemCode = (section.target.value === 'プチギフト' || section.target.value === '贈呈用ギフト')
    },
    search () {
      const sectionSRadio = document.getElementById('est-section-s')
      if (sectionSRadio !== null) {
        const sectionSInputs = sectionSRadio.querySelectorAll('input[name="estSectionS"]')
        let isChecked = false
        for (let i = 0; i < sectionSInputs.length; i++) {
          if (sectionSInputs[i].checked) {
            isChecked = true
          }
        }
        isChecked ? this.execSearch() : this.$refs.commonModal.msgBoxOk('小区分を選択してください')
      } else {
        this.execSearch()
      }
    },
    execSearch: async function () {
      const searchData = await this.createSearchData([
        document.getElementById('est-project-types'),
        document.getElementById('est-section-s'),
        document.getElementById('est-search-conditions')
      ])
      localStorage.setItem('searchData', JSON.stringify(searchData))
      this.overlayShow = true
      const resData = await SearchModel.apiSetStore(this.$bvModal, searchData, () => {
        this.overlayShow = false
      })
      this.searchItems = resData['items']
    },
    createSearchData (targetElements) {
      let searchData = {}
      for (let elem of targetElements) {
        if (elem === null) {
          continue
        }
        const inputs = elem.querySelectorAll('input')
        for (let i = 0; i < inputs.length; i++) {
          if ((inputs[i].type === 'checkbox' || inputs[i].type === 'radio') && inputs[i].checked === false) {
            continue
          }
          if ((inputs[i].type === 'text' || inputs[i].type === 'number') && !inputs[i].value) {
            continue
          }
          if (inputs[i].dataset.paramName in searchData) {
            searchData[inputs[i].dataset.paramName].push(inputs[i].value)
          } else {
            searchData[inputs[i].dataset.paramName] = [inputs[i].value]
          }
        }
      }
      return searchData
    },
    addEstimateItem: async function () {
      const addEstItemCode = document.getElementsByName('addEstItemCode')
      let params = []
      for (var i = 0; i < addEstItemCode.length; i++) {
        if (addEstItemCode[i].checked && addEstItemCode[i].value) {
          params.push({'projectType': this.projectType === 'メインテーブル' || this.projectType === 'ゲストテーブル' ? 'メインテーブル・ゲストテーブル' : this.projectType, 'itemCode': addEstItemCode[i].value})
        }
      }
      if (params.length) {
        this.overlayShow = true
        await EstimateRegistModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
        this.$emit('reloadEstimate')
        this.hideModal()
      } else {
        this.$refs.commonModal.msgBoxOk('商品を選択してください')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AddEstimateItemModal.vue